import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./AmbientalL1.module.css";

function AmbientalL1({ distrito }) {
  const [nascentes, setNascentes] = useState(null);
  const [aguaCorrente, setAguaCorrente] = useState(null);
  const [mata, setMata] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [nascentes, aguaCorrente, mata] = await Promise.all(
          [
            Api.getNascentes(distrito),
            Api.getAguaCorrente(distrito),
            Api.getMata(distrito),
          ]
        );
        setNascentes(Functions.buildSmallPieGraphParams(nascentes));
        setAguaCorrente(Functions.buildSmallPieGraphParams(aguaCorrente));
        setMata(Functions.buildSmallPieGraphParams(mata));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  const mockupFunction = (value) => {
    value = value + 1;
  };
  return (
    <div className={styles.ambientalL1}>
      <div className={styles.smallPiegraph}>
        {nascentes && (
          <SmallPieGraph
            data={nascentes}
            text="NASCENTES"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {aguaCorrente && (
          <SmallPieGraph
            data={aguaCorrente}
            text="ÁGUA CORRENTE"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {mata && (
          <SmallPieGraph
            data={mata}
            text="MATA"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>
    </div>
  );
}

export default AmbientalL1;
